
<template>
  <div
    class="bg-white relative px-4 pb-4 pt-2 rounded-lg shadow-md justify-center flex flex-col"
  >
    <div class="font-bold text-lg flex gap-2 items-center">
      {{ props.title }}
      <LoadingSpinner :size="20" v-if="props.loading"/>
    </div>
    <div class="flex gap-6 pb-4">
      <div v-for="tab in props.tabs" :key="tab.id"
          class="font-medium text-sm  cursor-pointer w-fit"
          :class="[currentTab.id === tab.id ? 'text-blue-500' : 'text-midea-text hover:text-blue-500']"
          @click="emit('update:currentTab', tab)"
      >
          {{tab.text}}
      </div>
    </div>

    <Line
      class="block 3xl:hidden cursor-pointer"
      style="height: 300px"
      :chartOptions="chartOptions"
      :chartData="props.data"
    />

    <Line
      class="hidden 3xl:block cursor-pointer"
      style="height: 400px"
      :chartOptions="chartOptions"
      :chartData="props.data"
    />
  </div>
</template>

<script setup>
  import { defineProps, defineEmits } from 'vue'
  import { Line } from 'vue-chartjs'
  import { Chart as ChartJS, Title, Tooltip, LinearScale, CategoryScale, PointElement, LineElement } from 'chart.js'
  import LoadingSpinner from './LoadingSpinner.vue';

  ChartJS.register(Title, Tooltip, LinearScale, CategoryScale, PointElement, LineElement)

  const props = defineProps(['title', 'tabs', 'currentTab', 'data', 'loading', 'formatDate'])
  const emit = defineEmits(['update:currentTab', 'chartClick'])

  const chartOptions = {
    onClick: (e, activeEls) => {
      const dataIndex = activeEls[0].index;
      const label = e.chart.data.labels[dataIndex];
      emit("chartClick", label);
    },
    responsive: true,
    maintainAspectRatio: false,
    bezierCurve: true,
    elements: {
      point: {
        radius: 0
      }
    },
    scales: {
      x: {
        ticks: {
          callback: function(value) {
            return props.formatDate(props.data.labels[value]);
          }
        },
        grid: {
          display: false,
          drawBorder: false,
        }
      },
      y: {
        grid: {
          drawBorder: false,
        }
      },
    },
    interaction: {
      mode: 'index',
      intersect: false
    },
    plugins: {
        tooltip: {
            callbacks: {
                title: function(context) {
                    return props.formatDate(context[0].label)
                }
            }
        }
    }
  }
</script>
